import { BaseIP } from "../CommonAPI/CommonApi"


//============Customer Master API============
export const GetCustomerMaster=BaseIP+"master/CustomerMaster/getCustomerMasterList"  // Customer Master Get Data 
export const GetCustomerMasterById=BaseIP+"master/CustomerMaster/getCustomerMaster"  // Customer Master Get Data By Id (params=> ?id=1)
export const SaveCustomerMaster=BaseIP+"master/CustomerMaster/saveCustomerMaster"  // Customer Master Save Data 
export const UpdateCustomerMaster=BaseIP+"master/CustomerMaster/updateCustomerMaster"  // Customer Master Update Data 
export const DeleteCustomerMaster=BaseIP+"master/CustomerMaster/deleteCustomerMaster"  // Customer Master Delete Data (params=> ?id=1)


//============Consignee Master API============
export const GetConsigneeMaster=BaseIP+"master/ConsigneeMaster/getConsigneeMasterList"  // Consignee Master Get Data 
export const GetConsigneeMasterById=BaseIP+"master/ConsigneeMaster/getConsigneeMaster"  // Consignee Master Get Data By Id (params=> ?id=1)
export const SaveConsigneeMaster=BaseIP+"master/ConsigneeMaster/saveConsigneeMaster"  // Consignee Master Save Data 
export const UpdateConsigneeMaster=BaseIP+"master/ConsigneeMaster/updateConsigneeMaster"  // Consignee Master Update Data 
export const DeleteConsigneeMaster=BaseIP+"master/ConsigneeMaster/deleteConsigneeMaster"  // Consignee Master Delete Data (params=> ?id=1)


//============Rate Master API============
export const GetRateMaster=BaseIP+"master/RateMaster/getRateMasterList"  // Rate Master Get Data 
export const GetRateMasterById=BaseIP+"master/RateMaster/getRateMaster"  // Rate Master Get Data By Id (params=> ?id=1)
export const SaveRateMaster=BaseIP+"master/RateMaster/saveRateMaster"  // Rate Master Save Data 
export const UpdateRateMaster=BaseIP+"master/RateMaster/updateRateMaster"  // Rate Master Update Data 
export const DeleteRateMaster=BaseIP+"master/RateMaster/deleteRateMaster"  // Rate Master Delete Data (params=> ?id=1)